
import React, { useEffect, useState } from "react"
import TreeNodeSession from "./TreeNodeSession"
import GUI, { IGUIProps } from "../GUI"
import ChevronRight from "../Icons/ChevronRight"

export type TTreeNode<T> = {
    _id:string
    name:string
    expanded:boolean
    parentId:string|null

    children:TTreeNode<T>[]
    parent:TTreeNode<T>|null

    addToggleHandler?:(handler:any) => TTreeNode<T>
    removeToggleHandler?:(handler:any) => TTreeNode<T>
}

export type TTreeNodeProps<T> = IGUIProps & {
    level:number
    node:TTreeNode<T>
    selectedId:string
    session:TreeNodeSession<T>|null
    onChange:(node:TTreeNode<T>)=>void
}

function Directory<T extends TTreeNode<T>>(props:{level:number, node:T, expanded:boolean, selected: boolean, onClick:()=>void}) {
    const className = GUI.joinClass("dir flex middle gap-4", {
        expanded:props.expanded,
        selected:props.selected,
    })
    const style : React.CSSProperties = {
        paddingLeft:`calc(var(--TREE_INDENTATION) * ${props.level})`
    }
    return <div className={className} onClick={props.onClick} style={style}>
        <ChevronRight className="arrow"/>
        {props.node.name}
    </div>
}

export default function TreeNode<T extends TTreeNode<T>>(props:TTreeNodeProps<T>) {
    const {node,selectedId,session,onChange} = props
    const [expanded,setExpanded] = useState<boolean>(node.expanded)
    const level = props.level || 0
    const onClick = async () => {
        if (props.selectedId!=node._id) {
            node.expanded = true
            session?.toggle(node)
            onChange(node)
            setExpanded(true)            
        }
        else {
            node.expanded = !expanded
            session?.toggle(node)
            setExpanded(!expanded)
        }
    }

    const onToggle = (node:TTreeNode<T>) => setExpanded(node.expanded)

    useEffect(() => {
        node.addToggleHandler?.(onToggle)
        return () => {node.removeToggleHandler?.(onToggle)}
    },[])

    const nodes = expanded && node.children.length ? node.children.map(child => <TreeNode level={level+1} node={child} key={child._id} selectedId={selectedId} session={session} onChange={onChange}/>) : null
    return <>
        <Directory level={level} node={node} expanded={expanded} selected={selectedId==node._id} onClick={onClick}/>
        {nodes}
    </>
}
